// جدول تقرير الحضور + صندوق الشرح والتذييل — بنفس أنماط تقرير الرواتب.
import { LEAVE_BADGE } from "../payroll/reportTokens";
import { esc, firstFive, shortDate, today } from "../payroll/reportFormat";
import { chunk, pageFoot, signature } from "../payroll/reportPages";
import { attTotalsRow } from "./attTotalsRow";

const badges = (breakdown, L) =>
  Object.entries(breakdown || {})
    .filter(([, item]) => item.count > 0)
    .map(([kind, item]) => {
      const [bg, fg] = LEAVE_BADGE[kind] || LEAVE_BADGE.unpaid;
      const { shown, more } = firstFive(item.dates);
      const dates = shown.map(shortDate).join(" ") + (more ? " …" : "");
      return `<span class="badge" style="background:${bg};color:${fg}">${esc(L.leaveTypes[kind] || kind)} ${item.count}` +
        `${dates ? ` · ${esc(dates)}` : ""}</span>`;
    })
    .join("");

const absenceLine = (dates) => {
  const { shown, more } = firstFive(dates);
  return shown.length ? `<div class="sub neg">${esc(shown.join(", "))}${more ? " …" : ""}</div>` : "";
};

const row = (e, L) => {
  const weekendTone = e.paid_weekends < e.total_weekends ? "neg" : "pos";
  return `<tr>
    <td><span class="b">${esc(e.employee_name)}</span><div class="sub">${esc(e.branch_name)}</div></td>
    <td class="b">${e.days_worked}</td>
    <td class="${e.absence_days > 0 ? "danger b" : ""}">${e.absence_days}${absenceLine(e.absence_dates)}</td>
    <td class="${e.late_count > 0 ? "danger b" : ""}">${e.late_count}</td>
    <td>${e.leave_days}<div>${badges(e.leave_breakdown, L)}</div></td>
    <td class="${weekendTone} b">${e.total_weekends}/${e.paid_weekends}</td>
  </tr>`;
};

export const table = (data, L) => {
  const head = L.cols.map((c) => `<th>${esc(c)}</th>`).join("");
  const pages = chunk(data.employees.map((e) => row(e, L)));
  const foot = attTotalsRow(data, L);
  return pages
    .map((rows, i) => {
      const last = i === pages.length - 1;
      return `<div class="sheet"><table><thead><tr>${head}</tr></thead><tbody>${rows.join("")}</tbody>${
        last ? foot : ""
      }</table>
        ${last ? "" : pageFoot(i + 1, pages.length, L)}</div>${last ? "" : '<div class="pagebreak"></div>'}`;
    })
    .join("");
};

export const pageCount = (data) => chunk(data.employees).length;

export const explain = (L) =>
  `<div class="explain"><div class="b">${esc(L.explainTitle)}</div>${L.explain
    .map(([term, text]) => `<div><span class="b">${esc(term)}:</span> ${esc(text)}</div>`)
    .join("")}</div>`;

export const warning = (data, L) => {
  const names = (data.weekend_days || []).map((d) => L.weekdays[d] || d).join(" · ") || L.none;
  return `<div class="warn">
    <div class="title">${esc(L.warnTitle)}</div>
    <div><span class="b">${esc(L.weekendIs)}</span> ${esc(names)}</div>
    <div>${esc(L.paidWhen)}</div>
  </div>`;
};

export const footer = (L, pages = 1) =>
  `${signature(L)}<div class="footer">${esc(L.footer)} | ${today()} | ${esc(
    L.pageOf.replace("{i}", pages).replace("{n}", pages),
  )}</div>`;
